import type { Link } from '@packages/domain/models/link';
import type { RootState } from 'reducers/types';
import { requiresDocuments } from 'selectors/entities/documents/documents';
import {
  isCAP,
  isNonClientRecipient,
} from 'selectors/entities/recipient/recipient';
import {
  docCollectorFinished,
  shouldShowWhatsappSubscriptions,
} from 'selectors/ui/ui';

export const getLinkById = (state: RootState, id: string): Link | null => {
  const {
    entities: { links },
  } = state;

  return links[id] || null;
};

const getInitiateLink = (state: RootState, links: Record<string, Link>) => {
  const { initiate = null } = links;

  if (requiresDocuments(state) && !docCollectorFinished(state)) {
    return;
  }

  return initiate;
};

const getSmsNotificationLink = (
  state: RootState,
  links: Record<string, Link>,
) => {
  if (!links.sms_notification) {
    return;
  }
  if (isCAP(state)) {
    return;
  }
  if (shouldShowWhatsappSubscriptions(state)) {
    return;
  }

  return links.sms_notification;
};

const getReceiptLink = (state: RootState) => {
  return getLinkById(state, 'receipt');
};

const getDocumentDownloadLinks = (state: RootState) => {
  if (isNonClientRecipient(state)) {
    const proofOfPayment = getLinkById(state, 'proof_of_payment');
    const confirmationLetter = getLinkById(state, 'confirmation_letter');

    return {
      ...(proofOfPayment && { proofOfPayment }),
      ...(confirmationLetter && { confirmationLetter }),
    };
  }

  const receipt = getReceiptLink(state);
  const guaranteedReceipt = getLinkById(state, 'guaranteed_receipt');

  return {
    ...(receipt && { receipt }),
    ...(guaranteedReceipt && { guaranteedReceipt }),
  };
};

export const getManagementLinks = (state: RootState): Record<string, Link> => {
  const {
    entities: { links },
  } = state;

  const initiate = getInitiateLink(state, links);
  const cancellation = getLinkById(state, 'cancellation');
  const smsNotification = getSmsNotificationLink(state, links);
  const booking = getLinkById(state, 'booking');

  return {
    ...(initiate && { initiate }),
    ...(cancellation && { cancellation }),
    ...(smsNotification && { sms_notification: smsNotification }),
    ...getDocumentDownloadLinks(state),
    ...(booking && { booking }),
  };
};
